export default "__VITE_ASSET__BdRjip5v__"